export enum OrderLoaderKey {
  LIST_ORDERS = 'order-list',
  GET_ORDER = 'order-get',
  CREATE_ORDER = 'order-create',
  UPDATE_ORDER = 'order-update',
  LINK_SHIPMENT = 'order-link-shipment',
}
